import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("polygon", {
		fill: "#FFFFFF",
		points: "14.85,5.86 14.14,5.15 10,9.29 5.86,5.15 5.15,5.86 9.29,10 5.15,14.14 5.86,14.85 10,10.71 14.14,14.85 14.85,14.14 10.71,10 "
	})
});
export default SvgClose;
